<div class="AMFlightInfoBanner bg-am-darkblue">
 <div class="col-10 fs-28px fw-semibold">
   {{ typeError | translate }} {{ typeError2 | translate }}
 </div>
 <div class="col-2">
   <button class="btn btn-info  px-5 py-2 fs-25px" (click)="onClick()">{{ 'CONTINUE' | translate }}</button>
 </div>
</div>
